var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wi100 hi100",attrs:{"id":"risk"}})
}
var staticRenderFns = []

export { render, staticRenderFns }